module.exports = __webpack_public_path__ + "img/measurement_info_back_hips_right.f92273e5.jpg";